import { Dispatch } from "@reduxjs/toolkit"

import { subscribe } from "@/sockets/utils"
import { updateDrivers } from "@/store/drivers"
import { updateNotifications } from "@/store/notifications"
import { updateOrders } from "@/store/orders"
import { updateTeamsStats } from "@/store/teamsStats"
import { Driver, Notification, Order, TeamStats } from "@/types"

// TODO: Stricter typing
export type Channel = {
  subscribe: (teamUuid: string) => ReturnType<typeof subscribe>
  // TODO: better typing for sockets
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleUpdates: (dispatch: Dispatch, updates: any[]) => void
}

export const Channels: { [channelName: string]: Channel } = {
  "Teams::DriversChannel": {
    subscribe: (teamUuid) => subscribe("Teams::DriversChannel", teamUuid),
    handleUpdates: (dispatch: Dispatch, updates: Array<{ data: Driver[] }>) => {
      dispatch(updateDrivers(updates.map((update) => update.data).flat()))
    },
  },
  NotificationChannel: {
    subscribe: (teamUuid) => subscribe("NotificationChannel", teamUuid),
    handleUpdates: (dispatch: Dispatch, updates: Array<{ data: Notification }>) => {
      dispatch(updateNotifications(updates.map((update) => update.data)))
    },
  },
  OrderChannel: {
    subscribe: (teamUuid) => subscribe("OrderChannel", teamUuid),
    handleUpdates: (dispatch: Dispatch, updates: Array<{ data: Order }>) => {
      dispatch(updateOrders(updates.map((update) => update.data)))
    },
  },
  TeamChannel: {
    subscribe: (teamUuid) => subscribe("TeamChannel", teamUuid),
    handleUpdates: (dispatch: Dispatch, updates: Array<{ data: TeamStats }>) => {
      dispatch(updateTeamsStats(updates.map((update) => update.data)))
    },
  },
}
